<!-- This component acts as a router to open the modal -->
<div class="webview-router">
  <!-- Loading State: Show when opening modal OR when URL is provided but modal not ready -->
  <div
    *ngIf="isLoading || (webviewUrl && !isModalReady)"
    class="loading-container"
  >
    <ion-spinner name="crescent" color="primary"></ion-spinner>
    <p class="loading-text">
      {{ isLoading ? 'Opening assessment...' : 'Preparing assessment...' }}
    </p>
    <!-- Debug info -->
    <!-- <p style="font-size: 12px; margin-top: 10px; color: white;">
      Debug: isLoading={{ isLoading }}, hasUrl={{ !!webviewUrl }}
    </p> -->
  </div>

  <!-- Success State: Show when modal is ready (this will be brief) -->
  <div *ngIf="!isLoading && webviewUrl && isModalReady" class="ready-state">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Assessment Ready</ion-card-title>
        <ion-card-subtitle>Opening in modal...</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <p>The assessment is being opened in a modal window.</p>
      </ion-card-content>
    </ion-card>
  </div>

  <!-- Inactive State: Show when no URL provided -->
  <div *ngIf="!webviewUrl && !isLoading" class="inactive-state">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Webview Router</ion-card-title>
        <ion-card-subtitle>Ready to launch assessment</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <p>
          This component routes to the webview modal when an assessment URL is
          provided.
        </p>
      </ion-card-content>
    </ion-card>
  </div>
</div>
